import Mutations from '../../odata/mutations';

export default { ...new Mutations('fleetSupplier'), ...new Mutations('fleetSuppliers') };
